module.exports = "../images/cabins-bg@2x.jpg?v=98cdc5f";